export var ENTITY = "bank-account";
export var REDUCER_KEY = "BANK_ACCOUNT";
export var BASE_PATH_ENTITY = "bank-accounts";
export var GENERATOR_PARAMS = {
    entity: ENTITY,
    reducerKey: REDUCER_KEY,
    basePathEntity: BASE_PATH_ENTITY,
    legacyGetDetail: true,
};
